
import { Component, Vue } from 'vue-property-decorator';
import { handleStoreIntegrationCallback } from '../../helpers/eCommerce';
import { AddStorePayload, PlatformType } from '../../types';

@Component
export default class CallbackEbay extends Vue {
  get code(): string | null {
    return this.$route.query.code as string;
  }

  get state(): string | null {
    return this.$route.query.state as string;
  }

  async mounted() {
    if (!this.code || !this.state) return;

    const decodedState = decodeURIComponent(this.state);
    const [nonce, shopURL, displayName] = decodedState.split(',');

    const payload: AddStorePayload = {
      platformType: PlatformType.eBay,
      inputFields: [
        { fieldId: 'StoreUrl', value: shopURL },
        { fieldId: 'DisplayName', value: displayName },
        { fieldId: 'Code', value: this.code },
        { fieldId: 'Nonce', value: nonce },
      ],
    };

    await handleStoreIntegrationCallback(payload);
  }
}
